export const iconFontAwesomeScienceClipboardCheck = (
	<i className="fa-solid fa-clipboard-check"></i>
);
